import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const UnitsRoutes: RouteBundle = {
  domain: 'units',
  routes: [{urlPattern: 'units/listing', handler: EditorRoutes.unitsDictionaryListing.bind(EditorRoutes)}],
};
